import { styleTags, tags as t } from "@lezer/highlight";

export const mongoHighlighting = styleTags({
  BsonType: t.keyword,
  BsonKeyword: t.keyword,
  PropertyKey: t.propertyName,
  String: t.string,
  Number: t.number,
  Boolean: t.atom,
  Null: t.null,
  LineComment: t.lineComment,
  BlockComment: t.blockComment,
  Regex: t.regexp,
  TemplateVariable: t.special(t.variableName),
  SpecialNumber: t.number,
  "{ }": t.brace,
  "[ ]": t.squareBracket,
  "( )": t.paren,
  ",": t.separator,
  ":": t.punctuation,
});
